<template>
  <div class="video-caption">
    <h2 class="video-caption__title" :style="{ color: titleColor }">
      {{ title }}
    </h2>
    <div class="video-caption__text" v-html="description"></div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "BrandChannelContent",
  computed: mapState({
    title: state => state.brandChannel.tape.brand_channel.title,
    description: state => state.brandChannel.tape.brand_channel.description,
    titleColor: state => state.brandChannel.tape.brand_channel.title_color
  })
};
</script>

<style>
.video-caption__title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 10px;
}

.video-caption__text {
  font-size: 12px;
  color: #666;
}
</style>
